__turbopack_context__.v({
  "className": "abcp3rman3ntfont_a5505b40-module__vhZ7iG__className",
  "variable": "abcp3rman3ntfont_a5505b40-module__vhZ7iG__variable",
});
